import React from "react";
import { Badge, Box, Card, Flex, Text } from "@chakra-ui/react";
import { FeatureList } from "./PlanCard";
import type { PlanFeature, StakingTierData } from "./types";

interface StakingPlanCardProps {
  plan: StakingTierData;
  matchingPlanDescription?: string;
  // TODO(overage-credits): restore — see projects/pro/docs/overage-credits-scope.md
  // overageText?: string;
  isCurrentPlan: boolean;
  button: React.ReactNode | null;
}

export const StakingPlanCard: React.FC<StakingPlanCardProps> = ({
  plan,
  matchingPlanDescription,
  // TODO(overage-credits): restore — see projects/pro/docs/overage-credits-scope.md
  // overageText,
  isCurrentPlan,
  button,
}) => {
  const isRecommended = plan.tier === 6;
  const titleText = isCurrentPlan ? `${plan.name || `Tier ${plan.tier}`} (Current Plan)` : (plan.name || `Tier ${plan.tier}`);

  const features: PlanFeature[] = [
    { text: `${plan.credits.toLocaleString()} credits/month*`, included: true },
    // TODO(overage-credits): restore — see projects/pro/docs/overage-credits-scope.md
    // { text: overageText || "Overage credits", included: true },
    { text: `${plan.callsPerMinute} requests/minute`, included: true },
    { text: "All standard endpoints", included: true },
    { text: "AI Agent-friendly endpoints", included: true },
    { text: "Full web-socket access", included: plan.hasWebSocket },
    { text: "MCP server and agent skills", included: plan.hasWebSocket },
    { text: plan.tier === 5 ? "Personal/non-profit license" : "Full commercial-use license", included: true },
  ];

  return (
    <Card.Root
      flex={1}
      minWidth="240px"
      width="full"
      alignSelf="stretch"
      css={isRecommended && !isCurrentPlan
        ? { border: "2px solid", borderColor: "#2dd4bf", boxShadow: "0px 0px 1px 0px rgba(24,24,27,0.3), 0px 4px 8px 0px rgba(24,24,27,0.1)" }
        : isCurrentPlan
        ? { bg: "#f4f4f5" }
        : { boxShadow: "0px 0px 1px 0px rgba(24,24,27,0.3), 0px 2px 4px 0px rgba(24,24,27,0.1)" }}
    >
      <Card.Body display="flex" flexDir="column">
        <Flex alignItems="center" gap="2px" mb={0}>
          <Text
            fontSize="md"
            fontWeight="bold"
            lineHeight="24px"
            color={isRecommended && !isCurrentPlan ? "#2dd4bf" : "black"}
            flex={isRecommended && !isCurrentPlan ? 1 : undefined}
          >
            {titleText}
          </Text>
          {isRecommended && !isCurrentPlan && (
            <Badge colorPalette="teal" variant="subtle">Recommended</Badge>
          )}
        </Flex>

        <Flex flexDir="column" gap={0} mb={6}>
          <Flex alignItems="center" gap={2}>
            <Text fontSize="48px" fontWeight={800} lineHeight="60px">{plan.minStakedBalance}</Text>
            <Box>
              <Text fontSize="sm" color="#a1a1aa" lineHeight="20px">Staked</Text>
              <Text fontSize="sm" color="#a1a1aa" lineHeight="20px">MOR</Text>
            </Box>
          </Flex>
        </Flex>

        {matchingPlanDescription && (
          <Text fontSize="sm" color="#52525b" lineHeight="20px" mb={6}>
            {matchingPlanDescription}
          </Text>
        )}

        <FeatureList features={features} />

        {button && <Box pt={2} width="full">{button}</Box>}
      </Card.Body>
    </Card.Root>
  );
};
